import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Checkbox } from '@/components/ui/checkbox';

const AddVaccinationDialog = ({ open, onClose, onAdd }) => {
  const [formData, setFormData] = useState({
    name: '',
    date_received: new Date().toISOString().split('T')[0],
    booster_required: false,
    booster_due_date: '',
    adverse_reactions: '',
    notes: '',
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await onAdd({
        ...formData,
        booster_due_date: formData.booster_due_date || undefined,
        adverse_reactions: formData.adverse_reactions || undefined,
        notes: formData.notes || undefined,
      });

      setFormData({
        name: '',
        date_received: new Date().toISOString().split('T')[0],
        booster_required: false,
        booster_due_date: '',
        adverse_reactions: '',
        notes: '',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[600px]">
        <DialogHeader>
          <DialogTitle>Add Vaccination</DialogTitle>
          <DialogDescription>Record immunization information</DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit}>
          <div className="grid gap-4 py-4">
            <div className="grid gap-2">
              <Label htmlFor="name">Vaccine Name *</Label>
              <Input id="name" placeholder="e.g., COVID-19, Flu, Tetanus" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} required />
            </div>

            <div className="grid gap-2">
              <Label htmlFor="date_received">Date Received *</Label>
              <Input id="date_received" type="date" value={formData.date_received} onChange={(e) => setFormData({ ...formData, date_received: e.target.value })} required />
            </div>

            <div className="flex items-center space-x-2">
              <Checkbox
                id="booster_required"
                checked={formData.booster_required}
                onCheckedChange={(checked) => setFormData({ ...formData, booster_required: checked })}
              />
              <Label htmlFor="booster_required" className="font-normal cursor-pointer">Booster required</Label>
            </div>

            {formData.booster_required && (
              <div className="grid gap-2">
                <Label htmlFor="booster_due_date">Booster Due Date</Label>
                <Input id="booster_due_date" type="date" value={formData.booster_due_date} onChange={(e) => setFormData({ ...formData, booster_due_date: e.target.value })} />
              </div>
            )}

            <div className="grid gap-2">
              <Label htmlFor="adverse_reactions" className="text-red-600">Adverse Reactions (if any)</Label>
              <Textarea
                id="adverse_reactions"
                value={formData.adverse_reactions}
                onChange={(e) => setFormData({ ...formData, adverse_reactions: e.target.value })}
                rows={2}
                className="border-red-300"
              />
            </div>

            <div className="grid gap-2">
              <Label htmlFor="notes">Additional Notes</Label>
              <Textarea id="notes" value={formData.notes} onChange={(e) => setFormData({ ...formData, notes: e.target.value })} rows={2} />
            </div>
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={onClose}>Cancel</Button>
            <Button type="submit" disabled={loading} className="bg-[#B8E6D5] hover:bg-[#A0D6C5] text-gray-900">
              {loading ? 'Adding...' : 'Add Vaccination'}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default AddVaccinationDialog;